import { Avatar, Grid, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import AccessTime from "@mui/icons-material/AccessTime";
import { getAvatarText, timeFromNow } from "@utils";
import {
  CommentOut,
  CommentAttachmentOut,
} from "@providers/hop-ord-server/api";
import ImageBox from "@components/ImageBox/ImageBox";

const Comment = ({
  createdBy,
  id,
  createdAt,
  attachments,
  content,
}: CommentOut) => {
  const initials = getAvatarText(createdBy);

  return (
    <Stack
      sx={{
        gap: 1,
        border: "1px solid",
        borderColor: "borderColor.main",
        borderRadius: 1,
        padding: 1,
      }}
    >
      <Stack
        direction="row"
        sx={{
          gap: 1,
        }}
      >
        <Avatar>{initials}</Avatar>
        <Stack sx={{ flex: 1 }}>
          <Stack direction="row" sx={{ justifyContent: "space-between" }}>
            <Typography data-testid={`${id}-comment-author`}>
              {createdBy}
            </Typography>
            <Stack
              direction="row"
              sx={{
                alignItems: "center",
                gap: 1,
                color: "text.secondary",
              }}
            >
              <AccessTime fontSize="small" />
              <Typography
                data-testid={`${id}-comment-createdAt`}
                variant="body2"
              >
                {createdAt && timeFromNow(createdAt)}
              </Typography>
            </Stack>
          </Stack>
          <Typography
            data-testid={`${id}-comment-content`}
            variant="body2"
            sx={{ wordBreak: "break-word" }}
          >
            {content}
          </Typography>
        </Stack>
      </Stack>
      {attachments.length > 0 && (
        <Grid container spacing={0.5}>
          {attachments.map((attachment: CommentAttachmentOut, i: number) => {
            return (
              <Grid key={`image-url-${i}`} size={6}>
                <ImageBox
                  testId={`${i}-comment-image`}
                  key={`${i}-image-path-key`}
                  fileName={attachment.fileName}
                  url={attachment.url}
                />
              </Grid>
            );
          })}
        </Grid>
      )}
    </Stack>
  );
};

export default Comment;
